export const mapToNodes = <T>(
  data?: null | {
    edges: ({ node?: null | undefined | T } | null | undefined)[]
  },
): T[] => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return data?.edges?.map((edge) => edge!.node!) || []
}
